import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.less']
})
export class ButtonComponent implements OnInit {
  @Input() caption = '';
  @Input() disabled = false;
  @Input() size? = 'small';
  @Input() color?: 'primary' |  'secundairy' ='primary'
  _color: string = '#d69e00';
  constructor() { }

  ngOnInit(): void {
    switch(this.color) {
      case 'primary':
          this._color = '#d69e00';
          break;
      case 'secundairy':
        this._color = '#d69e00';
        break;
    }

  }

}
